<template>

  <v-card
    :disabled="!expand && !completed"
    class="col-12 pa-0 mb-4 bt-step-card"
  >
    <v-card-title>
      {{ title }}
      <v-spacer />
      <v-btn
        v-if="expand && !selectedSegment"
        small
        outlined
        color="primary"
        @click="createSegment"
        class="mr-3"
      >
        Create New Segment
      </v-btn>
      <v-btn
        v-if="expand"
        :disabled="!valid || !expand || (!segment || segment.items.length == 0)"
        small
        color="primary"
        @click="complete"
      >
        Next step
      </v-btn>
    </v-card-title>
    <v-divider v-if="expand" />

    <v-card-text class="pa-0">
      <v-expand-transition>
        <v-form
          v-if="expand"
          v-model="valid"
          class="px-3 pb-7"
        >
          <v-row class="mx-0">
            <v-col
              cols="12"
              md="4"
            >

              <v-select
                v-model="selectedSegment"
                :items="segmentList"
                label="Select segment"
                persistent-hint
                hint="You can select segment or create you own Typography"
                return-object
              />

            </v-col>

            <v-col
              cols="12"
              md="4"
              style="line-height: 70px"
            >
              <v-btn
                :disabled="!selectedSegment"
                small
                color="primary"
              >
                Load segment
              </v-btn>
            </v-col>

          </v-row>

          <v-container
            class="px-4"
            v-if="segment"
            fluid
          >

            <v-row class="mx-0">

              <v-text-field
                class="col-3"
                label="Segment name"
                v-model="segment.name"
                :rules="[v => !!v || 'Segment name is required']"
                required
              />

              <v-spacer />
              <v-btn
                small
                color="light-blue lighten-2 mt-8"
                dark
                @click="addSegmentItem"
              >
                Add Rule
              </v-btn>
            </v-row>

            <div class="segment-wrapper">
              <v-sheet
                v-for="(item, i) of (segment.items)"
                :key="'segment-sheet-item-' + i"
                class="segment-rule-item v-sheet--outlined py-5 my-3"
                style="width: calc(100% - 100px)"
              >

                <v-icon
                  class="float-right mr-2"
                  @click="removeRule(i)"
                  v-if="segment.items.length > 1"
                >
                  mdi-delete
                </v-icon>

                <v-row class="mx-3" style="width: calc(100% - 150px);">
                  <v-select
                    class="col-4"
                    v-model="item.field"
                    :items="fields"
                    label="Field"
                    placeholder=" "
                    :rules="[v => !!v || 'Field is required']"
                    hide-details
                  />
                  <v-col class="ma-0 pa-0" cols="8">
                    <v-row class="ma-0 pa-0" v-for="(g, j) in item.values" :key="item.field + '-' + j">
                      <v-select
                        class="col-5"
                        v-model="item.values[j].equation"
                        :items="equations"
                        label="Equation"
                        hide-details
                        placeholder=" "
                        :rules="[v => !!v || 'Equation is required']"
                      />
                      <v-text-field
                        class="col-6"
                        label="Value"
                        v-model="item.values[j].value"
                        required
                        hide-details
                        placeholder=" "
                        :rules="[v => !!v || 'Value is required']"
                      />
                      <v-hover v-slot="{ hover }">
                        <v-icon class="mr-1" :color="hover ? 'green' : 'green lighten-3'" @click="addSegmentItemValue(i, j)">mdi-plus-circle-outline</v-icon>
                      </v-hover>
                      <v-hover v-slot="{ hover }">
                        <v-icon v-if="item.values.length > 1"  :color="hover ? 'red' : 'red lighten-3'" @click="removeSegmentItemValue(i, j)">mdi-minus-circle-outline</v-icon>
                      </v-hover>
                    </v-row>
                  </v-col>

                </v-row>

              </v-sheet>


              <div class="segment-and-icon-wrapper text-center">

                <div class="segment-and-icon-wrapper_lines top-lines" :style="{height: calcTopHeight}">
                  <div>
                    <div v-for="(k,j) of (lines)" class="" :style="{position: 'absolute', width: '50%', height:  '10px', top: (top[j])+ 'px' }" />
                    <v-divider vertical :style="{top: top[0] + 10 + 'px'}" />
                  </div>
                </div>

                <v-divider v-if="rulesBlockHeight.length % 2 == 1 && rulesBlockHeight.length > 1" />
                <v-btn
                  v-if="rulesBlockHeight.length > 1"
                  outlined
                  color="blue"
                  rounded
                  class="segment-and-icon"
                >
                  AND
                </v-btn>

                <div class="segment-and-icon-wrapper_lines bottom-lines" :style="{height: calcBottomHeight}">
                  <div>
                    <v-divider vertical :style="{top: -(rulesBlockHeight[rulesBlockHeight.length - 1] / 2) + 15 + 'px'}" />
                    <div v-for="(k,j) of (lines)" class="" :style="{position: 'absolute', width: '50%', height:  '10px', top: (top[lines.length + j + (rulesBlockHeight.length % 2 == 0 ? 0 : 1) ])+ 'px' }" />
                  </div>
                </div>
              </div>
            </div>

          </v-container>
        </v-form>
      </v-expand-transition>
    </v-card-text>
  </v-card>

</template>

<style lang="scss">

  .v-card.v-card--disabled .v-card__title {
    background: #cbcbcb;
  }

  .v-card.v-card--disabled.bt-step-card {
    border-left-color: gray;
  }

  .v-card.bt-step-card {
    border-left: 4px solid #4caf50;
  }

  .segment-wrapper .segment-and-icon-wrapper .v-divider {
    width: 17px;
    bottom: -19px;
    position: relative;
  }

  .segment-wrapper .segment-and-icon-wrapper .segment-and-icon-wrapper_lines {
    width: 100%;
    overflow: hidden;
    flex-direction: column-reverse;
  }

  .segment-wrapper .segment-and-icon-wrapper .segment-and-icon-wrapper_lines.top-lines > div > div {
    border-top: thin solid #e1e0e0;
  }

  .segment-wrapper .segment-and-icon-wrapper .segment-and-icon-wrapper_lines.bottom-lines > div > div {
    border-bottom: thin solid #e1e0e0;
  }


  .segment-wrapper .segment-and-icon-wrapper .segment-and-icon-wrapper_lines.top-lines > div,
  .segment-wrapper .segment-and-icon-wrapper .segment-and-icon-wrapper_lines.bottom-lines > div {
    position: relative;
    height: 100%;
  }

  .segment-wrapper .segment-and-icon-wrapper .segment-and-icon-wrapper_lines.bottom-lines > div {
    margin-top: -18px;
  }

  .segment-wrapper .segment-and-icon-wrapper .segment-and-icon-wrapper_lines.top-lines > div > .v-divider,
  .segment-wrapper .segment-and-icon-wrapper .segment-and-icon-wrapper_lines.bottom-lines > div > .v-divider {
    height: 100%;
    border-right: none;
    border-top: none;
    border-bottom: none;
    border-color: #e1e0e0;
    border-left-width: thin;
    max-width: 2px;
    width: 2px;
  }

  .segment-wrapper .segment-and-icon-wrapper .segment-and-icon-wrapper_lines.top-lines > div > div:first-child {
    -webkit-border-top-right-radius: 5px;
    -moz-border-radius-topright: 5px;
    border-top-right-radius: 5px;
  }

  .segment-wrapper .segment-and-icon-wrapper .segment-and-icon-wrapper_lines.bottom-lines > div > div:last-child {
    -webkit-border-bottom-right-radius: 5px;
    -moz-border-radius-bottomright: 5px;
    border-bottom-right-radius: 5px;
  }


  .segment-wrapper .segment-and-icon-wrapper .segment-and-icon-wrapper_lines > div > div {
    width: 50%;
    border-right: thin solid #e1e0e0;
  }

  .segment-wrapper .segment-and-icon-wrapper {
    position: absolute;
    right: 0px;
    top: 0;
    width: 100px;
    /* bottom: 0px; */
    height: 100%;

  }

  .segment-wrapper .segment-and-icon {
  }

  .segment-wrapper {
    position: relative;
  }

</style>

<script>
  import { toArray, toNumber } from 'lodash'

  export default {

    props: {
      step: {},
      value: {},
      next: {},
      extvalid: {},
      exteditable: {},
      extcompleted: {},
      title: {},
      expand: { default: () => false },
    },

    data: () => ({
      selectedSegment: null,
      segmentList: [],
      segment: null,
      rulesBlockHeight: [],
      top: [],
      fields: [
        { value: 'deposit.count', text: 'Deposit count' },
        { value: 'deposit.amount', text: 'Deposit amount' },
        { value: 'account.type', text: 'Account type' },
        { value: 'account.country', text: 'Account country' },
        { value: 'account.language', text: 'Account language' },
        { value: 'account.currency', text: 'Account currency' },
        { value: 'account.affiliate', text: 'Affiliate' },
        { value: 'account.btag', text: 'B-Tag' },
        { value: 'account.level', text: 'VIP Level' },
        { value: 'account.unfunded', text: 'Unfunded days' },
      ],
      equations: [
        { value: '=', text: 'Equal to' },
        { value: '!=', text: 'Not Equal to' },
        { value: '>', text: 'More than' },
        { value: '<', text: 'Less than' },
        { value: '>=', text: 'More or equal to' },
        { value: '<=', text: 'Less or equal to' },
      ]
    }),

    methods: {
      addSegmentItemValue (field) {
        this.segment.items[field].values.push({})
      },
      removeSegmentItemValue (field, j) {
        this.segment.items[field].values.splice(j, 1)
      },
      addSegmentItem () {
        if (!this.segment.items) this.segment.items = []
        this.segment.items.push({
          field: '',
          values: [ {} ]
        })
      },
      createSegment () {
        if (!this.segment) {
          this.segment = { name: '', items: [ { field: '', values: [ {} ] } ] }
        }
      },
      removeRule (i) {
        this.segment.items.splice(i, 1)
      },

      complete () {

        this.completed = true

        this.next(this.step)
      }
    },

    computed: {
      lines () {
        return [ ...Array(Math.floor(this.segment.items.length / 2)).keys() ]
      },
      calcTopHeight () {

        let height = 0
        if (this.lines.length == 0) return height

        for (let k in this.lines) {
          height += this.rulesBlockHeight[k]
        }

        if (this.rulesBlockHeight.length % 2 == 1) {
          height += (this.rulesBlockHeight[Math.floor(this.rulesBlockHeight.length / 2)] || 0) / 2
        }

        return (height - 18) + 'px'
      },
      calcBottomHeight () {

        let height = 0

        for (let k in this.rulesBlockHeight) {
          let key = +k + Math.floor(this.rulesBlockHeight.length / 2)

          if (this.rulesBlockHeight.length % 2 == 1) key += 1

          height += this.rulesBlockHeight[key] || 0
        }

        if (this.rulesBlockHeight.length % 2 == 1) {
          height += (this.rulesBlockHeight[Math.floor(this.rulesBlockHeight.length / 2)] || 0) / 2
        }

        return (height - 18) + 'px'
      },
      valid: {
        get () {
          return this.extvalid
        },
        set (v) {
          this.$emit('update:extvalid', v)
        }
      },
      editable: {
        get () {
          return this.exteditable
        },
        set (v) {
          this.$emit('update:exteditable', v)
        }
      },
      completed: {
        get () {
          return this.extcompleted
        },
        set (v) {
          this.$emit('update:extcompleted', v)
        }
      },
    },

    watch: {
      expand (v) {
        this.editable = true
      },

      'segment.items': {
        deep: true,
        handler: function () {

          this.$nextTick(() => {
            this.rulesBlockHeight = []
            this.top = []

            let elements = toArray(this.$el.querySelectorAll('.segment-rule-item'))

            let top = 0

            for (let i in elements) {
              let margin = parseFloat(window.getComputedStyle(elements[i], null).getPropertyValue('margin-bottom'))
              this.rulesBlockHeight[i] = elements[i].clientHeight + margin

              top += (this.rulesBlockHeight[i - 1] || 0)
              if (Math.ceil(elements.length / 2) == i) {
                top = elements.length % 2 == 0 ? 0 : ((elements[Math.floor(elements.length / 2)].clientHeight) / 2)
              }
              this.top[i] = top + (this.rulesBlockHeight[i] / 2)
            }
          })
        }
      }
    }
  }
</script>

